import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { ComponentHelper } from '@argalis-apps/angular-global';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as moment from 'moment';
import { animate, style, transition, trigger } from '@angular/animations';
import { SelectorService } from '../../../services/selector/selector.service';
import { MSelector } from '@argalis-apps/models';
import { Observable } from 'rxjs';
import { ApprenantService } from '../../../services/apprenant/apprenant.service';
@Component({
  selector: 'ags-session-apprenant',
  templateUrl: './session-apprenant.component.html',
  styleUrls: ['./session-apprenant.component.scss'],
  animations: [
    trigger('alertDisplay', [
      transition(':enter', [
        style({ transform: 'scale(0.8)', opacity: '0', height: '0' }),
        animate(100, style({ height: '100%' })),
        animate(300, style({ transform: 'scale(1)', opacity: '1' }))
      ]),
      transition(':leave', [
        animate(300, style({ transform: 'scale(0.5)', opacity: '0' })),
        animate(100, style({ height: '0' }))
      ])
    ])
  ]
})
export class SessionApprenantComponent extends ComponentHelper implements OnInit {
  @HostBinding('class') themeFlag;
  public apprenantData: any[];
  public apprenantForm: UntypedFormGroup;
  public opened = false;
  public chossedApprenant: any;
  public submitedForm = false;
  public typeApprenentList: Observable<MSelector.ITypeApprenantSelector[]>;
  public departementList: Observable<MSelector.IIntervenantDepartementsSelector[]>;
  public titleDialog = '';

  public errorServer = false;
  public idSession: string;
  public pays = null;
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }

  constructor(
    private accountConfigService: AccountConfigService,
    private apprenantService: ApprenantService,
    private selectorService: SelectorService
  ) {
    super();
  }

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.getListOfApprenant(this.idSession);
  }

  getListOfApprenant(idSession) {
    //TODO change id of session
    this.apprenantService.getApprenantBySession(idSession).subscribe(info => {
      this.apprenantData = info;
    });
  }

  /* Permet de fermer la popup */
  close() {
    this.submitedForm = false;
    this.opened = false;
  }
  getSelectosInfo() {
    this.getTypeOfApprenent();
    this.getListOfDepartement();
    this.getPays();
  }
  getTypeOfApprenent() {
    this.typeApprenentList = this.selectorService.getTypeOfApprenantSelector();
  }
  getListOfDepartement() {
    this.departementList = this.selectorService.getIntervenantDepartementSelector();
  }

  getPays() {
    this.pays = this.selectorService.getPays();
  }

  /* Permet d'ouvrir la popup */
  open(apprenant: any) {
    this.titleDialog = `Fiche de l'apprenant - ${apprenant.nom}`;
    this.chossedApprenant = apprenant;
    this.getSelectosInfo();
    const zipRegix = /^[0-9]\d{4}/;
    const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    const phoneRegex = /^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}$/;
     // On initialise le formulaire
    this.apprenantForm = new UntypedFormGroup({
      adresse: new UntypedFormControl(apprenant.adresse || ''),
      adresse_mail: new UntypedFormControl(apprenant.adresse_mail || ''),
      id_pays: new UntypedFormControl(apprenant.id_pays || ''),
      nom_naissance: new UntypedFormControl(apprenant.nom_naissance || ''),
      civilite: new UntypedFormControl(apprenant.civilite),
      cp: new UntypedFormControl(apprenant.cp || ''),
      date_naissance: new UntypedFormControl(apprenant.date_naissance ? new Date(apprenant.date_naissance).toISOString().split('T')[0] : ''),
      id_apprenant: new UntypedFormControl(apprenant.id_apprenant),
      id_client: new UntypedFormControl(apprenant.id_client),
      id_dpt_naissance: new UntypedFormControl(apprenant.id_dpt_naissance),
      id_session_apprenant: new UntypedFormControl(apprenant.id_session_apprenant),
      id_type: new UntypedFormControl(apprenant.id_type),
      matricule: new UntypedFormControl(apprenant.matricule || ''),
      nom: new UntypedFormControl(apprenant.nom || ''),
      nom_client: new UntypedFormControl(apprenant.nom_client || ''),
      num_ident: new UntypedFormControl(apprenant.num_ident),
      observation: new UntypedFormControl(apprenant.observation || ''),
      pays_naissance: new UntypedFormControl(apprenant.pays_naissance || ''),
      prenom: new UntypedFormControl(apprenant.prenom || ''),
      telephone: new UntypedFormControl(apprenant.telephone || ''),
      ville: new UntypedFormControl(apprenant.ville || ''),
      ville_naissance: new UntypedFormControl(apprenant.ville_naissance || ''),
      photo: new UntypedFormControl(apprenant.photo || '')
    });

    this.apprenantForm
      .get('nom')
      .valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(console.log);
    this.opened = true;
  }

  handleFormApprenant($event: Event) {
    this.submitedForm = true;
    if (!this.apprenantForm.invalid) {
      $event.preventDefault();
      const apprenant = Object.assign({}, this.apprenantForm.value);
      if (apprenant.date_naissance) {
        apprenant.date_naissance = moment(apprenant.date_naissance).format('YYYY-MM-DD');
      } else {
        apprenant.date_naissance = '';
      }
      this.apprenantService.updateApprenantInfo(this.apprenantForm.value.id_session_apprenant, apprenant).subscribe(
        () => {
          this.submitedForm = false;
          this.getListOfApprenant(this.idSession);
          this.errorServer = false;
          this.close();
        },
        () => {
          this.errorServer = true;
          this.submitedForm = false;
        }
      );
    } else {
      console.error('invalid form');
    }
  }
}
